export const environment = {
    production: false,
    serviceWorker: true,
    authentication: {
        server: 'https://hsiauth-dev.azurewebsites.net',
        clients: {
            hsiResourceOwner: {
                secret: 'BA5D5E55-BC8D-46C4-9AD9-6CD828614566',
                scope: 'SummitScope',
            },
            hsiResourceOwnerRef30: {
                secret: 'A20E3ADB-62D5-4287-96E1-4491B0717647',
                scope: 'openid VideoApp ClaimsData SummitScope',
            }
        }
    },
    microservice: {
        administration: 'https://ms-administration-dev.hsiplatformdev.com',
        featureFlagging: 'https://ms-featureflag-dev.hsiplatformdev.com',
        trainingResources: 'https://ms-trainingresources-dev.hsiplatformdev.com',
    } 
}